import './PagePaginator.css';
import pageIndexBackgroundImg from './page_index_background.png';

type PagePaginatorProps = {
  current: number;
  total?: number;
};

/** From welcome_screen_1.svg / Figma → page_index_background + page_index_text. */
export function PagePaginator({ current, total = 2 }: PagePaginatorProps) {
  return (
    <>
      <img
        className="page-paginator__background"
        src={pageIndexBackgroundImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <p className="page-paginator__text" role="status">
        {current}/{total}
      </p>
    </>
  );
}
